import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import { Values } from "@src/Tools/Values";
import AuthProvidersContent from "./AuthProvidersContent/AuthProvidersContent";

interface IProps {
  management?: IManagementStore;
}

@inject("management", "values")
@observer
export default class AuthProviders extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await Promise.all([
        this.props.management.getOAuthProviders(),
      ]);
      this.isLoading = false;
      document.title = Values.getLocalizationValue("oAuthProviders");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <AuthProvidersContent />}</div>;
  }
}
